import { render } from "./AssessmentScheduleReport.vue?vue&type=template&id=31a9ed48&scoped=true"
import script from "./AssessmentScheduleReport.vue?vue&type=script&lang=js"
export * from "./AssessmentScheduleReport.vue?vue&type=script&lang=js"

import "./AssessmentScheduleReport.vue?vue&type=style&index=0&id=31a9ed48&scoped=true&lang=css"

import exportComponent from "/var/www/tis-live/frontend/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31a9ed48"]])

export default __exports__